import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import truncate from "truncate-html";
import axios from "axios";

import "../../../assets/css/DetailsSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const hasValue = (value) =>
  typeof value === "string" &&
  value.trim() !== "" &&
  value !== "undefined" &&
  value !== "null";

const getImageUrl = (path) =>
  hasValue(path) ? `${BACKEND_URL}upload/${path}` : null;

const formatDate = (value) => {
  if (!value) return { day: "--", month: "---", year: "----" };

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return { day: "--", month: "---", year: "----" };
  }

  return {
    day: date.getDate(),
    month: date.toLocaleString("en", { month: "short" }).toUpperCase(),
    year: date.getFullYear(),
  };
};

function DetailsSection({
  datacontent = [],
  downloadSection = [],
  sideNewSection = [],
  advertSection = [],
  initialPagination,
  initialPaginationDownload,
  datacontentDataSearch,
}) {
  

  const [newsList, setNewsList] = useState(datacontent || []);
  const [downloadList, setDownloadList] = useState(downloadSection || []);
  const [page, setPage] = useState(1);
  const [pageDownload, setPageDownload] = useState(1);

  const [pagination, setPagination] = useState(
    initialPagination || { current_page: 1, last_page: 1 },
  );
  const [paginationDownload, setPaginationDownload] = useState(
    initialPaginationDownload || { current_page: 1, last_page: 1 },
  );

  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setNewsList(datacontent || []);
    setPage(1);
    setPagination(initialPagination || { current_page: 1, last_page: 1 });
  }, [datacontent, initialPagination]);

  useEffect(() => {
    setDownloadList(downloadSection || []);
    setPageDownload(1);
    setPaginationDownload(
      initialPaginationDownload || { current_page: 1, last_page: 1 },
    );
  }, [downloadSection, initialPaginationDownload]);

  const fetchNews = useCallback(async () => {
    if (!datacontentDataSearch?.value) return;

    setLoading(true);
    setLoadError(false);

    try {
      const response = await axios.get(`${BASE_URL}read-data`, {
        params: {
          id: datacontentDataSearch.value,
          read_page: page,
          download_page: pageDownload,
        },
      });

      const result = response?.data?.data;

      setNewsList(result?.readSection?.data || []);
      setDownloadList(result?.downloadSection?.data || []);
      setPagination(
        result?.readSection?.pagination || {
          current_page: page,
          last_page: 1,
        },
      );
      setPaginationDownload(
        result?.downloadSection?.pagination || {
          current_page: pageDownload,
          last_page: 1,
        },
      );
    } catch (error) {
      console.error("Unable to load article details:", error);
      setLoadError(true);
    } finally {
      setLoading(false);
    }
  }, [datacontentDataSearch?.value, page, pageDownload]);

  useEffect(() => {
    if (page > 1 || pageDownload > 1) {
      fetchNews();
    }
  }, [page, pageDownload, fetchNews]);

  const changePage = (newPage) => {
    const lastPage = Number(pagination?.last_page || 1);
    if (newPage >= 1 && newPage <= lastPage) setPage(newPage);
  };

  const changePageDownload = (newPage) => {
    const lastPage = Number(paginationDownload?.last_page || 1);
    if (newPage >= 1 && newPage <= lastPage) setPageDownload(newPage);
  };

  const renderPagination = (
    currentPage,
    lastPage,
    onPageChange,
    disabled = false,
    label = "Pagination",
  ) => {
    if (Number(lastPage) <= 1) return null;

    return (
      <nav className="ds-pagination" aria-label={label}>
        <span className="ds-pagination-label">
          Page <strong>{currentPage}</strong> of <strong>{lastPage}</strong>
        </span>
        <div className="ds-pagination-buttons">
          <button
            type="button"
            onClick={() => onPageChange(1)}
            disabled={disabled || currentPage <= 1}
            aria-label="First page"
          >
            «
          </button>
          <button
            type="button"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={disabled || currentPage <= 1}
            aria-label="Previous page"
          >
            ‹
          </button>
          <span className="ds-page-current">{currentPage}</span>
          <button
            type="button"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={disabled || currentPage >= lastPage}
            aria-label="Next page"
          >
            ›
          </button>
          <button
            type="button"
            onClick={() => onPageChange(lastPage)}
            disabled={disabled || currentPage >= lastPage}
            aria-label="Last page"
          >
            »
          </button>
        </div>
      </nav>
    );
  };

  const currentRead = Array.isArray(newsList) ? newsList : [];
  const dataArray = Array.isArray(sideNewSection) ? sideNewSection : [];
  const dataDownloadArray = Array.isArray(downloadList) ? downloadList : [];

  const currentItem = currentRead[0] || {};
  //const alignment = currentItem?.aligment009?.toLowerCase() || "center";
  const alignment =  "center";


  // Shuffle the ten most recent items so the MORE UPDATE stories can vary
  // between page loads while still prioritising recent content.
  const recentUpdates = [...dataArray]
    .sort((a, b) => {
      const dateA = new Date(a.daterqw).getTime() || 0;
      const dateB = new Date(b.daterqw).getTime() || 0;
      return dateB - dateA;
    })
    .slice(0, 10)
    .sort(() => Math.random() - 0.5)
    .slice(0, 2);

  const advert = advertSection.length
    ? advertSection[Math.floor(Math.random() * advertSection.length)]
    : null;

  const renderArticle = (item, index) => {
    const itemDate = formatDate(item.daterqw);
    const imageUrl = getImageUrl(item.passport);

    return (
      <article className="ds-article" key={item.id || index}>
        {imageUrl && (
          <figure className="ds-article-figure">
            <img
              src={imageUrl}
              alt={item.title || "Article image"}
              loading={index === 0 ? "eager" : "lazy"}
              decoding="async"
            />
            <span
              className="ds-image-date"
              aria-label={`${itemDate.day} ${itemDate.month} ${itemDate.year}`}
            >
              <span>{itemDate.month}</span>
              <strong>{itemDate.day}</strong>
              <span>{itemDate.year}</span>
            </span>
          </figure>
        )}

        {item.caption && (
          <div className="ds-article-caption">
            <HTMLDisplay html={item.caption} type="title" />
          </div>
        )}

        <div className="ds-article-content">
          <div className="ds-article-title">
            <HTMLDisplay html={item.story01 || ""} type="title" />
          </div>
          <div className="ds-article-body">
            <HTMLDisplay html={item.story01 || ""} type="body" />
          </div>

          {/* {item.id && (
            <Link to={`/read/${item.id}`} className="ds-read-more">
              Read Full Story <span aria-hidden="true">→</span>
            </Link>
          )} */}
        </div>
      </article>
    );
  };

  return (
    <section id="service-details" className="ds-section section">
      <div className="container">
        <header className="ds-section-heading">
          <span className="ds-eyebrow">NEWS &amp; INFORMATION</span>
          <h2>Latest Updates</h2>
          <span className="ds-heading-accent" />
        </header>

        <div
          className={`ds-layout ${alignment !== "center" ? "ds-layout-full" : ""}`}
        >
          <main
            className={`ds-main ${alignment === "center" ? "ds-main-with-sidebar" : "ds-main-full"}`}
          >
            {loading && (
              <div className="ds-status" role="status">
                Loading content...
              </div>
            )}

            {loadError && (
              <div className="ds-status ds-status-error" role="alert">
                Unable to load the requested content.
                <button type="button" onClick={fetchNews}>
                  Try Again
                </button>
              </div>
            )}

            {!loading && !loadError && currentRead.length === 0 && (
              <div className="ds-status">
                No content is available at the moment.
              </div>
            )}

            {!loadError && currentRead.map(renderArticle)}

            {renderPagination(
              Number(pagination?.current_page || page),
              Number(pagination?.last_page || 1),
              changePage,
              loading,
              "Article pagination",
            )}
          </main>

          {alignment === "center" && (
            <aside className="ds-sidebar">
              {recentUpdates.length > 0 && (
                <section className="ds-sidebar-panel">
                  <div className="ds-panel-heading">
                    <span className="ds-panel-icon" aria-hidden="true">
                      <i className="fa-solid fa-newspaper" />
                    </span>
                    <div>
                      <span className="ds-panel-eyebrow">STAY INFORMED</span>
                      <h3>More Updates</h3>
                    </div>
                  </div>

                  <div className="ds-recent-list">
                    {recentUpdates.map((item, index) => {
                      const itemDate = formatDate(item.daterqw);
                      const imageUrl = getImageUrl(item.passport);

                      return (
                        <article
                          className="ds-recent-item"
                          key={item.id || index}
                        >
                          {imageUrl && (
                            <Link
                              to={`/read/${item.id}`}
                              className="ds-recent-image"
                              aria-label={`Read ${item.title || "update"}`}
                            >
                              <img
                                src={imageUrl}
                                alt={item.title || "Recent update"}
                                loading="lazy"
                                decoding="async"
                              />
                            </Link>
                          )}

                          <div className="ds-recent-date">
                            {itemDate.day} {itemDate.month} {itemDate.year}
                          </div>

                          <div className="ds-recent-title">
                            <HTMLDisplay
                              html={item.story01 || ""}
                              type="title"
                            />
                          </div>

                          <Link
                            to={`/read/${item.id}`}
                            className="ds-recent-link"
                          >
                            Read More <span aria-hidden="true">→</span>
                          </Link>
                        </article>
                      );
                    })}
                  </div>
                </section>
              )}

              {advert && (
                <section className="ds-sidebar-panel">
                  <div className="ds-panel-heading">
                    <span className="ds-panel-icon" aria-hidden="true">
                      <i className="fa-solid fa-bullhorn" />
                    </span>
                    <div>
                      <span className="ds-panel-eyebrow">
                        PUBLIC INFORMATION
                      </span>
                      <h3>Awareness Zone</h3>
                    </div>
                  </div>

                  {getImageUrl(advert.passport) && (
                    <div className="ds-advert">
                      <img
                        src={getImageUrl(advert.passport)}
                        alt={advert.title || "Public information"}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  )}
                </section>
              )}

              <section className="ds-sidebar-panel ds-download-panel">
                <div className="ds-panel-heading">
                  <span className="ds-panel-icon" aria-hidden="true">
                    <i className="fa-solid fa-folder-open" />
                  </span>
                  <div>
                    <span className="ds-panel-eyebrow">DOCUMENT CENTRE</span>
                    <h3>Downloadable Resources</h3>
                  </div>
                </div>

                {dataDownloadArray.length === 0 ? (
                  <p className="ds-empty-downloads">
                    No documents are currently available.
                  </p>
                ) : (
                  <div className="ds-document-list">
                    {dataDownloadArray.map((file, index) => {
                      const fileUrl = getImageUrl(file.addressLink);

                      if (!fileUrl) return null;

                      return (
                        <a
                          key={file.id || index}
                          href={fileUrl}
                          download
                          target="_blank"
                          rel="noreferrer"
                          className="ds-document-item"
                        >
                          <span className="ds-document-icon">
                            <i
                              className="fa-regular fa-file-pdf"
                              aria-hidden="true"
                            />
                          </span>

                          <span className="ds-document-details">
                            <span className="ds-document-name">
                              {truncate(file.title || "Download document", 12, {
                                byWords: true,
                              })}
                            </span>
                            <small>Download document</small>
                          </span>

                          <i
                            className="fa-solid fa-download ds-download-icon"
                            aria-hidden="true"
                          />
                        </a>
                      );
                    })}
                  </div>
                )}

                {renderPagination(
                  Number(paginationDownload?.current_page || pageDownload),
                  Number(paginationDownload?.last_page || 1),
                  changePageDownload,
                  loading,
                )}
              </section>
            </aside>
          )}
        </div>
      </div>
    </section>
  );
}

export default React.memo(DetailsSection);
